import { UnderConstructionComponent } from "../../../components";

export const SettingPaymentMethodsIndexPage = () => {
  return (
    <div>
      <UnderConstructionComponent />
    </div>
  );
};
